
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-compressor/editor",
      function () {
        return require("private-next-pages/image-compressor/editor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-compressor/editor"])
      });
    }
  